import { Injectable } from '@angular/core';
import { io } from 'socket.io-client';
import { Observable, Subject } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class ChatService {
  //private url = 'http://localhost:3000';
  private url = 'https://data.apnabet.in';
  private url2 = 'https://bsf444.net';
  private socket;
  private socket2;
  private message: string;
  private messageUpdated = new Subject<{ message: any }>();

  private centralCounter: string;
  private centralCounterUpdated = new Subject<{ centralCounter: any }>();

  private scoreCounter: string;
  private scoreCounterUpdated = new Subject<{ scoreCounter: any }>();

  constructor() {
    this.socket = io(this.url, {
      transports: ['websocket']
    });

    // this.socket2 = io(this.url2, {
    //   transports: ['websocket']
    // });
  }

  public setOdds = (eventId) => {
    this.socket.emit('Event/Auto', eventId);
  }

  public getOdds = (eventId) => {
    this.socket.on('Event/Auto/' + eventId, (message) => {
      this.message = message;
      this.messageUpdated.next({
        message: this.message
      });
    });
  }

  public setCC = () => {
    this.socket.emit('stats', '');
  }

  public getCC = () => {
    this.socket.on('stats', (message) => {
      this.centralCounter = message;
      this.centralCounterUpdated.next({
        centralCounter: this.centralCounter
      });
    });
  }

  public setSC = () => {
    this.socket2.emit('stats', '');
  }

  public getSC = () => {
    this.socket2.on('stats', (message) => {
      this.scoreCounter = message;
      this.scoreCounterUpdated.next({
        scoreCounter: this.scoreCounter
      });
    });
  }

  public destorySocket = (eventId) => {
    this.socket.off('Event/Auto/' + eventId);
    this.socket.emit('destroy_room');
  }

  getUpdateMessageListner() {
    return this.messageUpdated.asObservable();
  }

  getUpdateCentralListner() {
    return this.centralCounterUpdated.asObservable();
  }

  getUpdateScoreListner() {
    return this.scoreCounterUpdated.asObservable();
  }
}